import Swiper from 'swiper';
import {Navigation, Pagination} from 'swiper/modules';

export const activitiesSwiper = (() => {
  const swipers = document.querySelectorAll('.activitiesSwiper');

  swipers.forEach((swiperEl) => {
    // Skip initialization if the swiper has an ancestor with class "content"
    if (swiperEl.closest('.content')) {
      return;
    }

    const id = swiperEl.getAttribute('data-id');
    const swiper = new Swiper(swiperEl, {
      slidesPerView: "auto",
      spaceBetween: 24,
      modules: [Navigation, Pagination],
      direction: 'horizontal',

      breakpoints: {
        480: {
          slidesPerView: "auto",
          spaceBetween: 24,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 32,
        },
      },

      pagination: {
        el: `.activitiesSwiper-${id}-pagination`,
      },

      navigation: {
        nextEl: `.activitiesSwiper-${id}-button-next`,
        prevEl: `.activitiesSwiper-${id}-button-prev`,
      },
    });
  });
})();
